import { Action } from '@ngrx/store';

import {
	Site,
	Point,
	BoundingPolygon,
	NewFacilityHierarchyLevel,
	FacilityHierarchyLevel,
	EditFacilityHierarchyLevel,
	NewFacilityHierarchyLevelName,
	EditFacilityHierarchyLevelName,
	FacilityHierarchyLevelName,
} from '../../sites';
import { AnimationPlayer } from '@angular/animations';

export enum SitesActionTypes {
	GetSites = '[Site] Get Sites',
	GetSitesSuccess = '[Site] Get Sites Success',
	GetSitesFailure = '[Site] Sites Failed to Retrieve',
	GetSite = '[Site] Get Site',
	GetSiteSuccess = '[Site] Get Site Success',
	GetSiteFailure = '[Site] Site Failed to Retrieve',
	UpdateSite = '[Site] Update Site',
	UpdateSiteSuccess = '[Site] Update Site Success',
	UpdateSiteFailure = '[Site] Site Failed to Update',
	AddSite = '[Site] Add Site',
	AddSiteSuccess = '[Site] Add Site Success',
	AddSiteFailure = '[Site] Failed to Add Site',
	RemoveSite = '[Site] Remove Site',
	RemoveSiteSuccess = '[Site] Remove Site Success',
	RemoveSiteFailure = '[Site] Failed to Remove Site',
	OpenDrawer = '[Site] Open Drawer',
	CloseDrawer = '[Site] Close Drawer',
	HoverSiteBoundary = '[Site] Hover Site Boundary',
	ClearSiteBoundaryHover = '[Site] Boundary Hover Cleared',
	RemoveBoundary = '[Site] Remove Boundary',
	AddFacilityHierarchyLevel = '[Site] Add FacilityHierarchy Level',
	AddFacilityHierarchyLevelSuccess = '[Site] Add FacilityHierarchy Level Success',
	AddFacilityHierarchyLevelFailure = '[Site] Add FacilityHierarchy Level Failure',
	UpdateFacilityHierarchyLevel = '[Site] Update FacilityHierarchy Level',
	UpdateFacilityHierarchyLevelSuccess = '[Site] Update FacilityHierarchy Level Success',
	UpdateFacilityHierarchyLevelFailure = '[Site] Update FacilityHierarchy Level Failure',
	DeleteFacilityHierarchyLevel = '[Site] Delete FacilityHierarchy Level',
	DeleteFacilityHierarchyLevelSuccess = '[Site] Delete FacilityHierarchy Level Success',
	DeleteFacilityHierarchyLevelFailure = '[Site] Delete FacilityHierarchy Level Failure',
	AddFacilityHierarchyLevelName = '[Site] Add FacilityHierarchy Level Name',
	AddFacilityHierarchyLevelNameSuccess = '[Site] Add FacilityHierarchy Level Name Success',
	AddFacilityHierarchyLevelNameFailure = '[Site] Add FacilityHierarchy Level Name Failure',
	UpdateFacilityHierarchyLevelName = '[Site] Update FacilityHierarchy Level Name',
	UpdateFacilityHierarchyLevelNameSuccess = '[Site] Update FacilityHierarchy Level Name Success',
	UpdateFacilityHierarchyLevelNameFailure = '[Site] Update FacilityHierarchy Level Name Failure',
	DeleteFacilityHierarchyLevelName = '[Site] Delete FacilityHierarchy Level Name',
	DeleteFacilityHierarchyLevelNameSuccess = '[Site] Delete FacilityHierarchy Level Name Success',
	DeleteFacilityHierarchyLevelNameFailure = '[Site] Delete FacilityHierarchy Level Name Failure',
	GetFacilityHierarchyLevelNamesForSite = '[Site] Get FacilityHierarchy Level Names For Site',
	GetFacilityHierarchyLevelNamesForSiteSuccess = '[Site] Get FacilityHierarchy Level Names For Site Success',
	GetFacilityHierarchyLevelNamesForSiteFailure = '[Site] Get FacilityHierarchy Level Names For Site Failure',
}

export class GetSites implements Action {
	readonly type = SitesActionTypes.GetSites;
}

export class GetSitesSuccess implements Action {
	readonly type = SitesActionTypes.GetSitesSuccess;

	constructor(public payload: Site[]) {}
}

export class GetSitesFailure implements Action {
	readonly type = SitesActionTypes.GetSitesFailure;

	constructor(public payload: string) {}
}

export class GetSite implements Action {
	readonly type = SitesActionTypes.GetSite;

	constructor(public siteId: any) {}
}

export class GetSiteSuccess implements Action {
	readonly type = SitesActionTypes.GetSiteSuccess;

	constructor(public payload: Site) {}
}

export class GetSiteFailure implements Action {
	readonly type = SitesActionTypes.GetSiteFailure;

	constructor(public payload: string) {}
}

export class UpdateSite implements Action {
	readonly type = SitesActionTypes.UpdateSite;

	constructor(public payload: any) {}
}

export class UpdateSiteSuccess implements Action {
	readonly type = SitesActionTypes.UpdateSiteSuccess;

	constructor(public payload: any) {}
}

export class UpdateSiteFailure implements Action {
	readonly type = SitesActionTypes.UpdateSiteFailure;

	constructor(public payload: string) {}
}

export class AddSite implements Action {
	readonly type = SitesActionTypes.AddSite;

	constructor(public payload: any) {}
}

export class AddSiteSuccess implements Action {
	readonly type = SitesActionTypes.AddSiteSuccess;

	constructor(public payload: any) {}
}

export class AddSiteFailure implements Action {
	readonly type = SitesActionTypes.AddSiteFailure;

	constructor(public payload: string) {}
}

export class RemoveSite implements Action {
	readonly type = SitesActionTypes.RemoveSite;

	constructor(public payload: any) {}
}

export class RemoveSiteSuccess implements Action {
	readonly type = SitesActionTypes.RemoveSiteSuccess;

	constructor(public payload: any) {}
}

export class RemoveSiteFailure implements Action {
	readonly type = SitesActionTypes.RemoveSiteFailure;

	constructor(public payload: string) {}
}

export class HoverSiteBoundary implements Action {
	readonly type = SitesActionTypes.HoverSiteBoundary;

	constructor(public boundaryId: string) {}
}

export class OpenDrawer implements Action {
	readonly type = SitesActionTypes.OpenDrawer;

	constructor() {}
}

export class CloseDrawer implements Action {
	readonly type = SitesActionTypes.CloseDrawer;

	constructor() {}
}

export class ClearSiteBoundaryHover implements Action {
	readonly type = SitesActionTypes.ClearSiteBoundaryHover;
}

export class RemoveBoundary implements Action {
	readonly type = SitesActionTypes.RemoveBoundary;
	constructor(public boundary: BoundingPolygon, public site: any) {}
}

export class AddFacilityHierarchyLevel implements Action {
	readonly type = SitesActionTypes.AddFacilityHierarchyLevel;

	constructor(public newFacilityHierarchyLevel: NewFacilityHierarchyLevel) {}
}

export class AddFacilityHierarchyLevelSuccess implements Action {
	readonly type = SitesActionTypes.AddFacilityHierarchyLevelSuccess;

	constructor(public facilityHierarchyLevel: any) {}
}

export class AddFacilityHierarchyLevelFailure implements Action {
	readonly type = SitesActionTypes.AddFacilityHierarchyLevelFailure;

	constructor(public error: any) {}
}

export class UpdateFacilityHierarchyLevel implements Action {
	readonly type = SitesActionTypes.UpdateFacilityHierarchyLevel;

	constructor(public editFacilityHierachyLevel: EditFacilityHierarchyLevel) {}
}

export class UpdateFacilityHierarchyLevelSuccess implements Action {
	readonly type = SitesActionTypes.UpdateFacilityHierarchyLevelSuccess;

	constructor(public facilityHierarchyLevel: any) {}
}

export class UpdateFacilityHierarchyLevelFailure implements Action {
	readonly type = SitesActionTypes.UpdateFacilityHierarchyLevelFailure;

	constructor(public error: any) {}
}

export class DeleteFacilityHierarchyLevel implements Action {
	readonly type = SitesActionTypes.DeleteFacilityHierarchyLevel;

	constructor(public levelId: string) {}
}

export class DeleteFacilityHierarchyLevelSuccess implements Action {
	readonly type = SitesActionTypes.DeleteFacilityHierarchyLevelSuccess;

	constructor() {}
}

export class DeleteFacilityHierarchyLevelFailure implements Action {
	readonly type = SitesActionTypes.DeleteFacilityHierarchyLevelFailure;

	constructor(public error: any) {}
}

export class AddFacilityHierarchyLevelName implements Action {
	readonly type = SitesActionTypes.AddFacilityHierarchyLevelName;

	constructor(public newFacilityHierachyLevelName: NewFacilityHierarchyLevelName) {}
}

export class AddFacilityHierarchyLevelNameSuccess implements Action {
	readonly type = SitesActionTypes.AddFacilityHierarchyLevelNameSuccess;

	constructor(public facilityHierarchyLevelName: any) {}
}

export class AddFacilityHierarchyLevelNameFailure implements Action {
	readonly type = SitesActionTypes.AddFacilityHierarchyLevelNameFailure;

	constructor(public error: any) {}
}

export class UpdateFacilityHierarchyLevelName implements Action {
	readonly type = SitesActionTypes.UpdateFacilityHierarchyLevelName;

	constructor(public editFacilityHierachyLevelName: EditFacilityHierarchyLevelName) {}
}

export class UpdateFacilityHierarchyLevelNameSuccess implements Action {
	readonly type = SitesActionTypes.UpdateFacilityHierarchyLevelNameSuccess;

	constructor(public facilityHierarchyLevelName: any) {}
}

export class UpdateFacilityHierarchyLevelNameFailure implements Action {
	readonly type = SitesActionTypes.UpdateFacilityHierarchyLevelNameFailure;

	constructor(public error: any) {}
}

export class DeleteFacilityHierarchyLevelName implements Action {
	readonly type = SitesActionTypes.DeleteFacilityHierarchyLevelName;

	constructor(public levelNameId: string) {}
}

export class DeleteFacilityHierarchyLevelNameSuccess implements Action {
	readonly type = SitesActionTypes.DeleteFacilityHierarchyLevelNameSuccess;

	constructor() {}
}

export class DeleteFacilityHierarchyLevelNameFailure implements Action {
	readonly type = SitesActionTypes.DeleteFacilityHierarchyLevelNameFailure;

	constructor(public error: any) {}
}

export class GetFacilityHierarchyLevelNamesForSite implements Action {
	readonly type = SitesActionTypes.GetFacilityHierarchyLevelNamesForSite;

	constructor(public siteId: string) {}
}

export class GetFacilityHierarchyLevelNamesForSiteSuccess implements Action {
	readonly type = SitesActionTypes.GetFacilityHierarchyLevelNamesForSiteSuccess;

	constructor(public topLevelName: FacilityHierarchyLevelName) {}
}

export class GetFacilityHierarchyLevelNamesForSiteFailure implements Action {
	readonly type = SitesActionTypes.GetFacilityHierarchyLevelNamesForSiteFailure;

	constructor(public error: any) {}
}

export type SitesActionsUnion =
	| GetSites
	| GetSitesSuccess
	| GetSitesFailure
	| GetSite
	| GetSiteSuccess
	| GetSiteFailure
	| AddSite
	| AddSiteSuccess
	| AddSiteFailure
	| RemoveSite
	| RemoveSiteSuccess
	| RemoveSiteFailure
	| UpdateSite
	| UpdateSiteSuccess
	| UpdateSiteFailure
	| HoverSiteBoundary
	| OpenDrawer
	| CloseDrawer
	| ClearSiteBoundaryHover
	| RemoveBoundary
	| AddFacilityHierarchyLevel
	| AddFacilityHierarchyLevelSuccess
	| AddFacilityHierarchyLevelFailure
	| UpdateFacilityHierarchyLevel
	| UpdateFacilityHierarchyLevelSuccess
	| UpdateFacilityHierarchyLevelFailure
	| DeleteFacilityHierarchyLevel
	| DeleteFacilityHierarchyLevelSuccess
	| DeleteFacilityHierarchyLevelFailure
	| AddFacilityHierarchyLevelName
	| AddFacilityHierarchyLevelNameSuccess
	| AddFacilityHierarchyLevelNameFailure
	| UpdateFacilityHierarchyLevelName
	| UpdateFacilityHierarchyLevelNameSuccess
	| UpdateFacilityHierarchyLevelNameFailure
	| DeleteFacilityHierarchyLevelName
	| DeleteFacilityHierarchyLevelNameSuccess
	| DeleteFacilityHierarchyLevelNameFailure
	| GetFacilityHierarchyLevelNamesForSite
	| GetFacilityHierarchyLevelNamesForSiteSuccess
	| GetFacilityHierarchyLevelNamesForSiteFailure;
